export const getResponseContext = (responseContext: string, nodeId: string): string =>
	`action?${nodeId}=${responseContext}`;
